var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColumn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1434.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1434.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#496DFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11945 l0 -855 2905 0 2905 0 0 855 0 855 -2905 0 -2905 0 0 -855z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10070 l0 -690 4100 0 4100 0 0 690 0 690 -4100 0 -4100 0 0 -690z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8535 l0 -685 7170 0 7170 0 0 685 0 685 -7170 0 -7170 0 0 -685z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6995 l0 -685 2135 0 2135 0 0 685 0 685 -2135 0 -2135 0 0 -685z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5375 l0 -605 1195 0 1195 0 0 605 0 605 -1195 0 -1195 0 0 -605z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3840 l0 -600 3930 0 3930 0 0 600 0 600 -3930 0 -3930 0 0 -600z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2220 l0 -690 600 0 600 0 0 690 0 690 -600 0 -600 0 0 -690z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 685 l0 -685 2305 0 2305 0 0 685 0 685 -2305 0 -2305 0 0 -685z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/column.08d85ff31877a7bd9827e134ebf74bdc.svg";
export { ForwardRef as ReactComponent };